import type { RouteKey } from '../utils/routes';
import { ModelName } from '../models/routes';

// User
const USER_URL = `${process.env.REACT_APP_USER_URL || '/api'}${
  process.env.REACT_APP_USE_MOCK === 'true' ? '/mock' : ''
}`;
export const LOGIN = `${USER_URL}/login`;
export const LOGOUT = `${USER_URL}/logout`;

// Translatable route keys — values are i18n key suffixes (routes.<value>)
export const NON_DISPONIBLE: RouteKey = 'non-disponible';
export const ERREUR_TECHNIQUE: RouteKey = 'erreur';
export const FORMULAIRE_INSCRIPTION: RouteKey = 'inscription';
export const INSCRIPTION_DOUBLON: RouteKey = 'inscription-doublon';
export const GENERIC_CONFIRMATION_PAGE: RouteKey = 'confirmation';
export const PLAN_DU_SITE: RouteKey = 'plan-du-site';

export const ESPACE_PRIVE: RouteKey = 'espace-prive';
export const PARCOURS_FORMATION: RouteKey = 'parcours-formation';
export const PARCOURS_FORMATION_RESULT: RouteKey = 'resultat';
export const BIBLIOTHEQUE_SAVOIR: RouteKey = 'bibliotheque-savoir';
export const BRIQUE_DE_SAVOIR: RouteKey = 'brique-de-savoir';
export const TEST_ORIENTATION: RouteKey = 'test-orientation';
export const TEST_ORIENTATION_RESULT: RouteKey = 'resultat';
export const EVENEMENTS: RouteKey = 'evenements';
export const PROFIL: RouteKey = 'mon-profil';
export const PROFIL_PROFIL: RouteKey = 'profil';
export const PROFIL_FAVORIS: RouteKey = 'favoris';
export const PROFIL_INFOS_PERSO: RouteKey = 'informations-personnelles';
export const PROFIL_CONTACTER_PILEJE: RouteKey = 'contacter-pileje';

// Non-translatable routes (brand names / technical)
export const HOMEPAGE_EMB = 'emb';
export const ARTICLE_EMB = 'article-emb';
export const PAGE_PUBLIQUES = 'page-publique';
export const PAGE_PRIVEES = 'page-privee';
export const HOMEPAGE_MEDEIS = 'medeis';
export const ARTICLE_MEDEIS = 'article-medeis';
export const PREVIEW = 'preview';
export const HOMEPAGE_SAGA_MICROBIOTES = 'saga-microbiotes';
export const HOMEPAGE_PODCASTS = 'au-coeur-du-vivant';

export const ROUTE_MODEL_MAP: { [key: string]: ModelName } = {};
ROUTE_MODEL_MAP[PARCOURS_FORMATION] = 'parcoursFormations';
ROUTE_MODEL_MAP[BRIQUE_DE_SAVOIR] = 'briqueSavoirs';
ROUTE_MODEL_MAP[TEST_ORIENTATION] = 'quizs';
ROUTE_MODEL_MAP[PAGE_PRIVEES] = 'pagePrivees';
ROUTE_MODEL_MAP[PAGE_PUBLIQUES] = 'pagePubliques';
ROUTE_MODEL_MAP[EVENEMENTS] = 'evenements';
